import types from './types'

const mutations = {
  [types.SET_USER] (state, data) {
    if (data) state.userInfo = data
  },
  [types.SET_MENU_LIST] (state, data) {
    // 菜单只需要获取一次
    if (data && data.length === 0) return (state.menus = data)
    if (state.menus && state.menus.length) return
    state.menus = data
  },
  [types.CLEAR_MENUS] (state) { // 清空菜单
    state.menus = []
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/module/user/mutations.js